import React, { useState } from "react";
import { postData } from "../lib/utils";
import { Link } from "react-router-dom";

function ForgotPassword() {

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const response = await postData(
        "admin/forgot-password",
        { email }
      );

      alert(
        response?.message ||
        "Reset link sent to your email"
      );

    } catch (error) {

      console.log(error);

      alert("Something went wrong");

    } finally {

      setLoading(false);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">

      {/* LEFT SIDE */}
      <div className="hidden md:block relative h-screen">

        <img
          src="/img/login-half.png"
          alt="Forgot Password"
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/50"></div>

        <div className="absolute bottom-16 left-12 z-10 text-white">

          
          <h1 className="text-5xl font-bold leading-tight mb-4">
            Reset Your   Password
          </h1>

          <p className="text-lg text-gray-200 max-w-md leading-relaxed">
            Don’t worry. We’ll help you get back into your account quickly.
          </p>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <section className="bg-gray-50 dark:bg-gray-900 flex items-center justify-center min-h-screen px-6 py-8">

        <div className="w-full max-w-md">

          <div className="w-full bg-white rounded-2xl shadow-2xl border border-gray-100 dark:bg-gray-800 dark:border-gray-700">

            <div className="p-8 space-y-6">

              <div>

                <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                  Forgot Password
                </h1>

                <p className="text-gray-500 mt-2">
                  Enter your registered email address
                </p>

              </div>

              <form
                className="space-y-5"
                onSubmit={handleSubmit}
              >

                {/* EMAIL */}
                <div>

                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Email Address
                  </label>

                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value)
                    }
                    placeholder="Enter your email"
                    className="bg-gray-50 border border-gray-300 text-gray-900 rounded-xl focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 block w-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    required
                  />
                </div>

                {/* BUTTON */}
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#0f172a] hover:bg-[#1e293b] text-white font-semibold py-3 rounded-xl transition"
                >
                  {
                    loading
                      ? "Sending..."
                      : "Send Reset Link"
                  }
                </button>

                {/* LOGIN */}
                <p className="text-sm text-center text-gray-500">

                  Remember your password?{" "}

                  <Link
                    to="/login"
                    className="font-semibold text-[#7a0a02] hover:underline"
                  >
                    Sign In
                  </Link>

                </p>

              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ForgotPassword;